import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'dva';
import { useIntl } from 'umi';
import ModalML from '@/components/ModalML';
import DataTableNativeML from '@/components/DataTableNativeML';
import ConsumptionRecordDetail from '@/pages/cm/mm/ml/containers/detail_components/CodeDetail';
import webStorage from '@/utils/storageManager';
import { fmtThousand } from '@/utils/comUtil';
import ResultListStyled from './ResultListStyled';

const ResultList = (props) => {
  //关于国际化
  const intl = useIntl();
  const { formatMessage } = intl;
  const loadingEffect = useSelector((state) => state.loading);
  const couponUseListLoading = loadingEffect.effects['cpUseList/getCpUseList'];
  const dispatch = useDispatch();
  //查询参数
  const { searchParam, setSearchParam } = props;
  console.log('searchParam', searchParam);
  // const [pageData, setPageData] = useState({
  //   pageSize: 10,
  //   pageNum: 1,
  // });

  //改变页码
  const changePage = (obj) => {
    setSearchParam({ ...searchParam, ...obj });
  };

  //列表数据
  const {
    data: cpUseList,
    total,
    hasNext,
  } = useSelector((state) => state.cpUseList?.cpUseList) || {};
  //列表数据
  const { allTotal } = useSelector((state) => state.cpUseList) || {};

  //获取数据接口
  const fetchCpUseList = useCallback(() => {
    dispatch({
      type: 'cpUseList/getCpUseList',
      payload: {
        values: {
          ...searchParam,
          searchCount: false,
        },
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    dispatch,
    searchParam.cardCode,
    searchParam.consumeEndTime,
    searchParam.consumeStartTime,
    searchParam.couponId,
    searchParam.sendStartTime,
    searchParam.sendEmdTime,
    searchParam.mobile,
    searchParam.pageNum,
    searchParam.pageSize,
    searchParam.refreshTime,
  ]);
  useEffect(() => {
    fetchCpUseList();
  }, [fetchCpUseList]);

  const fetchCpUseListNum = useCallback(() => {
    dispatch({
      type: 'cpUseList/getCpUseListNum',
      payload: {
        values: {
          ...searchParam,
          searchCount: true,
        },
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    dispatch,
    searchParam.cardCode,
    searchParam.consumeEndTime,
    searchParam.consumeStartTime,
    searchParam.couponId,
    searchParam.sendStartTime,
    searchParam.sendEmdTime,
    searchParam.mobile,
    searchParam.pageNum,
    searchParam.pageSize,
    searchParam.refreshTime,
  ]);
  useEffect(() => {
    fetchCpUseListNum();
  }, [fetchCpUseListNum]);

  // const handleClickExport = () => {
  //   download('/coupon/downloadConsumeList', { ...searchParam });
  // };
  // const typeList = [
  //   { name: '满减券', value: 'CASH_COUPON' },
  //   { name: '折扣券', value: 'DISCOUNT_COUPON' },
  //   //目前团购券不支持
  //   // { name: '团购券', value: 'GROUP_COUPON' },
  //   { name: '兑换券', value: 'EXCHANGE_COUPON' },
  //   // 满折券
  //   { name: '满折券', value: 'FULL_DISCOUNT_COUPON' },
  // ];
  const { COUPON_TYPE = [] } = webStorage.get('DICTOBJ') || {};
  const typeList = COUPON_TYPE.map((item) => ({
    value: item.dictCode,
    name: item.nameZh,
  }));
  //关于订单弹窗
  const [open, setOpen] = useState(false);
  const handleCancel = () => {
    setOpen(false);
  };
  const handleOrderDetail = (orderNo) => {
    if (orderNo) {
      dispatch({
        type: 'cpDataList/getOrderId',
        payload: {
          values: {
            orderNo,
          },
        },
        callback: (res) => {
          if (res.code === 0) {
            setOpen(true);
            // history.push({
            //   pathname: '/order/order_list/order_detail',
            //   query: { id: res.data },
            // });
          }
          console.log(res);
        },
      });
    }
  };
  const { orderData } = useSelector((state) => state.cpDataList) || {};
  const columns = [
    {
      title: formatMessage({ id: 'coupon.writeoff.c01.lbl01' }),
      align: 'center',
      id: 'ownerName',
      event: {
        // onClick: (value, row) => handleMemberDetail(row),
      },
      // tdCellStyle: { color: 'rgb(21,101,192)', cursor: 'pointer' },
      // width:200,
    },
    {
      title: formatMessage({ id: 'coupon.writeoff.c01.lbl02' }),
      align: 'center',
      id: 'memberCode',
      key: 'memberCode',
      width: 200,
    },
    {
      align: 'center',
      title: formatMessage({ id: 'coupon.writeoff.c01.lbl03' }),
      id: 'couponName',
      event: {
        // onClick: (value, row) => handleMemberDetail(row),
      },
      // tdCellStyle: { color: 'rgb(21,101,192)', cursor: 'pointer' },
      width: '200',
    },
    {
      title: formatMessage({ id: 'coupon.writeoff.c01.lbl04' }),
      align: 'center',
      id: 'couponType',
      key: 'couponType',
      // width: 120,
      render: (rows) => {
        const name = typeList.find((i) => i.value === rows.couponType)?.name;
        return <div>{name}</div>;
      },
    },
    {
      title: formatMessage({ id: 'coupon.writeoff.c01.lbl05' }),
      id: 'cardCode',
      key: 'cardCode',
      width: 220,
      align: 'center',
      // render: () => {
      //   let sex = '';
      //   sex = optionToKey(sexMap, text.gender);
      //   return sex;
      // },
    },
    {
      title: formatMessage({ id: 'coupon.writeoff.c01.lbl06' }),
      id: 'couponId',
      key: 'couponId',
      align: 'center',
      // render: () => {
      //   let sex = '';
      //   sex = optionToKey(sexMap, text.gender);
      //   return sex;
      // },
    },
    {
      title: formatMessage({ id: 'coupon.writeoff.c01.lbl07' }),
      align: 'center',
      id: 'mobile',
      key: 'mobile',
      // width: 220,
    },
    {
      title: formatMessage({ id: 'coupon.writeoff.c01.lbl08' }),
      align: 'center',
      event: {
        onClick: (value, row) => handleOrderDetail(row.orderNo),
      },
      tdCellStyle: {
        color: 'rgb(21,101,192)',
        cursor: 'pointer',
      },
      id: 'orderNo',
      key: '',
      width: 180,
    },
    {
      title: formatMessage({ id: 'coupon.writeoff.c01.lbl09' }),
      align: 'center',
      id: 'createDate',
      key: 'createDate',
      width: 200,
    },
    {
      title: formatMessage({ id: 'coupon.writeoff.c01.lbl10' }),
      align: 'center',
      id: 'receiveTime',
      key: 'receiveTime',
      width: 200,
    },
    {
      title: formatMessage({ id: 'coupon.writeoff.c01.lbl11' }),
      align: 'center',
      id: 'consumeTime',
      key: 'consumeTime',
      width: 200,
    },
    {
      title: '核销人',
      align: 'center',
      id: 'empName',
      key: 'empName',
      width: 200,
    },
    {
      title: '核销部门',
      align: 'center',
      id: 'depNames',
      key: 'depNames',
      width: 200,
    },

    {
      title: formatMessage({ id: 'coupon.writeoff.c01.lbl12' }),
      align: 'center',
      id: 'couponUseChannel',
      key: 'couponUseChannel',
      // render: ({ couponUseChannel }) => {
      //   switch (couponUseChannel) {
      //     case 1:
      //       return '官网';
      //     case 2:
      //       return 'App';
      //     case 3:
      //       return 'H5';
      //     case 4:
      //       return '微信';
      //     case 5:
      //       return '微信';
      //     case 6:
      //       return 'etoshop';
      //     default:
      //       return '线下';
      //   }
      // },
    },
  ];
  const headerTip = (
    <div className="number-wrapper">
      <div className="number">
        <span className="text">
          {formatMessage({ id: 'coupon.data.n02.lbl02' })}{' '}
        </span>
        <span> {fmtThousand(allTotal, 0)}</span>
      </div>
    </div>
  );
  return (
    <ResultListStyled>
      {/* <div className="export-wrapper">
        <Fab
          variant="extended"
          size="small"
          color="primary"
          aria-label="add"
          className="export"
          onClick={handleClickExport}
        >
          <ArchiveIcon sx={{ width: '24px', height: '24px' }} />
          下载
        </Fab>
      </div> */}

      <DataTableNativeML
        loading={couponUseListLoading}
        columns={columns}
        changePage={changePage}
        page={searchParam}
        paging={true}
        data={cpUseList}
        headerTip={headerTip}
        hasNext={hasNext}
        initP={true}
        total={total}
        columnKey="id"
      ></DataTableNativeML>
      <ModalML
        open={open}
        onClose={handleCancel}
        title={formatMessage({ id: 'cm.member.detail.d03.lbl01' })}
        isHasBcg={false}
      >
        <ConsumptionRecordDetail
          detail={{ ...orderData, orderItemList: orderData?.orderItems }}
        />
      </ModalML>
    </ResultListStyled>
  );
};
export default ResultList;
